<template>
<div>
  
    <div id="printBill">
        <CompanyInfo></CompanyInfo>
        
           <CompanyWatermark />
              <div class="content-wrapper">
     <div class="content-area">
  <div class="left-column">
     <p><span class="label">Name</span><span class="colon">:</span><span class="value">{{ patientDetails.name }}</span></p>
    <p><span class="label">Age</span><span class="colon">:</span><span class="value"> {{ patientDetails.age }}</span></p>
    <p><span class="label">Gender</span><span class="colon">:</span><span class="value">{{ patientDetails.gender }} </span></p>
     <p><span class="label">Doctor</span><span class="colon">:</span><span class="value">{{doctorName || billPrintData.doctorName}}</span></p>
  </div>
  <div class="right-column">
    <p><span class="label">Date</span><span class="colon">:</span><span class="value"> {{ formattedAppointmentDate }}</span></p>
    <p><span class="label">Reg No</span><span class="colon">:</span><span> {{ patientId }}</span></p>
    <p><span class="label">Bill No</span><span class="colon">:</span><span class="value"> {{ billPrintData.billId }}</span></p>
  </div>
</div>


        
        
      <table class="print-bill-table">
  <thead>
    <tr>
      
      <th>SI No</th>
      <th>Bill Description</th>
      <th>QTY</th>
      <th>Rate</th>
      <th>Amount</th>
      <th>Tax</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(item, index) in billPrintData.billItems" :key="index">
      
      <td>{{ item.slNo }}</td>
      <td>{{ item.billItem.name }}</td>
      <td>{{ item.qty }}</td>
      <td>{{ item.rate }}</td>
      <td>{{ item.amount }}</td>
      <td>{{ item.taxAmount }}%</td>
    </tr>
  </tbody>
</table>

<hr class="full-line" />

     
        

<div class="print-summary-block">
  <div class="left-section">
    <p><span class="label">Payment Mode</span><span class="colon">:</span><span class="value">{{ paymentModeText }}</span></p>
    <p><span class="label">Receipt Amount</span><span class="colon">:</span><span class="value">{{ billPrintData.receiptAmount }}</span></p>
    <p><span class="label">Balance Amount</span><span class="colon">:</span><span class="value">{{ billPrintData.balanceAmount }}</span></p>
  </div>

  <div class="right-section">
    <p><span class="label">Subtotal</span><span class="colon">:</span><span class="value">{{ billPrintData.subTotal }}</span></p>
    <p><span class="label">Discount</span><span class="colon">:</span><span class="value">{{ billPrintData.discount }}</span></p>
    <p><span class="label">Total Amount</span><span class="colon">:</span><span class="value">{{ billPrintData.totalAmount }}</span></p>
  </div>
</div>


<hr class="full-line" />
        
        
    </div>

    </div>
</div>
</template>

<script>
import CompanyInfo from '../components/CompanyInfo.vue';
import CompanyWatermark from '@/components/CompanyWatermark.vue'
export default {
   components: {
    CompanyInfo,
     CompanyWatermark
  
   
  },
    props: {
        billPrintData: {
            type: [Object, Array]
        },
        patientDetails: {
            type: [Object, Array]
        },
         doctorName: { 
    type: String, 
    default: "" 
  },
        patientId:[Number,String]
    },
computed: {
   formattedAppointmentDate() {
      if (!this.billPrintData.billDate) return "";

      const [year, month, day] = this.billPrintData.billDate.split("-");
      return `${day}/${month}/${year}`;  // convert to DD/MM/YYYY
    },

    
  paymentModeText() {
    const modes = {
      1: 'Cash',
      2: 'Check',
      3: 'Debit',
      4:'UPI',
      // Extend as needed
    };
      const id = this.billPrintData && this.billPrintData.paymentModeId;
    const mode = this.billPrintData && this.billPrintData.paymentMode;

    return mode || modes[id] || 'Not Available';
  }
}

}
</script>





